import BannerComp from "../../../components/BannerComp";
import FeatureCard from "../../../components/FeatureCard";
import FeatureImageContent from "../../../components/FeatureImageContent";
import ImageTextSection from "../../../components/ImageTextSection";
import ProPrograms from "../../../components/ProPrograms";
import Seo from "../../../components/Seo";
import {
  featuresCardData,
  proProgramsData,
} from "../../../data/brainmemorycare";
import { createBreadcrumbSchema, createWebPageSchema } from "../../../lib/seo";
import section1Image from "./brainmemorycare_section1.webp";
import section2Image from "./brainmemorycare_section2.webp";
import section3Image from "./brainmemorycare_section3.webp";

const seo = {
  title: "Brain Brightening & Memory Care | MIT4Doctors",
  description:
    "Enhances sharp thinking, memory, and quality of life in assisted living and memory care homes using safe, high-tech neurofeedback for lasting mental clarity.",
  schema: [
    createWebPageSchema({
      path: "/services/brain-memory-care",
      title: "Brain Brightening & Memory Care",
      description:
        "This enhances sharp thinking, memories, and life quality in assisted living & memory care homes. We use high-tech neurofeedback, a safe method that helps extend cognitive lifespan & mental clarity.",
    }),
    createBreadcrumbSchema(
      "/services/brain-memory-care",
      "Brain Brightening & Memory Care",
    ),
  ],
};

export default function BrainMemoryCare() {
  return (
    <>
      <Seo
        title={seo.title}
        metaTitle={seo.title}
        description={seo.description}
        canonicalPath="/services/brain-memory-care"
        schema={seo.schema}
      />
      <BannerComp
        heading="Brain Brightening & Memory Care"
        paragraph="This enhances sharp thinking, memories, and life quality in assisted living & memory care homes. We use high-tech neurofeedback, a safe method that helps extend cognitive lifespan & mental clarity."
        centered
        BannerBgImg="/img/banners/brainmemorycare_hero.webp"
      />

      <ImageTextSection
        image={section1Image}
        imageAlt="Modern Challenges have Modern Solutions"
        imagePosition="left"
        title="Modern Challenges have Modern Solutions"
        description={`A lot of people these days seem cranky, prone to memory loss, and likely to break out. The real cause? It's what's going on "behind the screen" of our thoughts and bodies. It's usually due to lingering stress, nerves, and PTSD. It's from our unpredictable world. With this knowledge, we can learn from shared experiences and build our resilience together.`}
        highlightWords="Modern Solutions"
      />

      <ProPrograms
        heading="Brain Brightening & Memory Care"
        highlightText="Beneficial for Seniors"
        description="Memory care is vital for older populations. The Brain Brightening program takes a proactive approach to preserving cognitive abilities. This program is ideal for seniors with memory issues or early dementia. Integrating our neurofeedback program can improve mental wellness."
        programs={proProgramsData}
      />

      <FeatureImageContent
        heading="Brighten Minds, Better Lives"
        description="It boosts seniors cognitive function and memory. This non-invasive, effective solution improves quality of life. It is a valuable addition to any assisted living or memory care facility."
        buttonLabel="Get Started"
        buttonUrl="/contact-us"
        imageAlt="Brighten Minds, Better Lives"
      />

      <ImageTextSection
        image={section2Image}
        imageAlt="Brain Brightening & Memory Care is Ideal For!"
        imagePosition="right"
        title="Brain Brightening & Memory Care is Ideal For!"
        highlightWords="Ideal For!"
        icon={true}
        subSections={[
          {
            listItems: [
              "Seniors experiencing mild cognitive decline or early dementia symptoms",
              "People in assisted living or memory care facilities",
              "Geriatric patients with age-related memory loss or focus issues",
              "Older adults looking for a proactive approach to cognitive health",
            ],
          },
        ]}
      />

      <FeatureCard
        sectionTitle="How the Program Works"
        sectionDescription="We use brain scans and custom neurofeedback to build up brain power. We track progress through regular sessions. This ensures we improve memory, concentration, and brain health."
        highlightText="Works"
        features={featuresCardData}
      />
      <ImageTextSection
        image={section3Image}
        imageAlt="Why Implement Brain Brightening in Your Facility?"
        imagePosition="left"
        title="Why Implement Brain Brightening in Your Facility?"
        description={`Offering the Brain Brightening and Memory Care Program allows your facility to:`}
        highlightWords="Your Facility?"
        subSections={[
          {
            listItems: [
              "Enhance your patient's quality of life with improved cognitive wellness",
              "Stand out by providing an innovative, non-invasive memory care service",
              "Generate additional revenue with zero upfront investment",
              "Provide a service that major insurers cover. It will be accessible to most people.",
            ],
          },
        ]}
      />
    </>
  );
}
